import React from 'react'
import styles from './Footer.module.css'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <>
     <footer className={styles.footer}>
     <div class="container my-5">
  <div className="container p-4 pb-0 text-center rounded">
    <section className="mb-4">
      <Link to={"https://www.facebook.com/S7s.fit.37/"} target='_blank' className="btn btn-primary btn-floating m-1" style={{backgroundColor: '#3b5998'}}  role="button"><i className="fab fa-facebook-f" /></Link>
      <Link to={"https://www.linkedin.com/in/hussein-mohamed-078476290/"} target='_blank'  className="btn btn-primary btn-floating m-1" style={{backgroundColor: '#55acee'}} role="button"><i className="fab fa-twitter" /></Link>
      <Link to={"s7so1234@gmail.com"} target='_blank'  className="btn btn-primary btn-floating m-1" style={{backgroundColor: '#dd4b39'}}  role="button"><i className="fab fa-google" /></Link>
      <Link to={"https://www.facebook.com/S7s.fit.37/"} target='_blank' className="btn btn-primary btn-floating m-1" style={{backgroundColor: '#ac2bac'}}  role="button"><i className="fab fa-instagram" /></Link>
      <Link to={"https://www.linkedin.com/in/hussein-mohamed-078476290/"} target='_blank' className="btn btn-primary btn-floating m-1" style={{backgroundColor: '#0082ca'}}  role="button"><i className="fab fa-linkedin-in" /></Link>
      <Link to={"https://github.com/HusseinMo21?tab=repositories"} target='_blank' className="btn btn-primary btn-floating m-1" style={{backgroundColor: '#333333'}}  role="button"><i className="fab fa-github" /></Link>
    </section>
  </div>
  <div className="text-center p-3" style={{backgroundColor: 'rgba(0, 0, 0, 0.2)'}}>
    © 2024 Copyright: 
    <Link className="text-white nav-link d-inline"> HM Services</Link>
  </div>
   </div>

  
     </footer> 
    </>
  )
}
